// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumLock-cls1_DSp","cls2":"PremiumLock-cls2_cOS PremiumLock-cls1_DSp"};